export default {
    name: 'UserBusiness',
    dimensions: { width: 40, height: 40 },
    content: `
    <g fill="currentColor" stroke="none">
      <path d="M18 2C21.31 2 24 4.69 24 8C24 11.31 21.31 14 18 14C14.69 14 12 11.31 12 8C12 4.69 14.69 2 18 2ZM18 16C22.41 16 26 12.41 26 8C26 3.59 22.41 0 18 0C13.59 0 10 3.59 10 8C10 12.41 13.59 16 18 16Z"/>
      <path d="M18 23.2L15.87 20H19.2C19.6 20 19.84 20.45 19.62 20.78L18 23.2ZM18 37.72L15.75 35.93C15.41 35.66 15.29 35.21 15.44 34.8L18 27.88L20.81 35.48L18 37.72ZM25 18H11C4.92 18 0 22.92 0 29V39C0 39.55 0.45 40 1 40C1.55 40 2 39.55 2 39V29C2 24.03 6.03 20 11 20H13.46L16.88 25.13L13.06 35.46C12.91 35.86 13.04 36.32 13.38 36.59L17.38 39.78C17.56 39.93 17.78 40 18 40C18.22 40 18.44 39.93 18.62 39.78L22.62 36.59C22.96 36.32 23.08 35.87 22.93 35.46L19.11 25.13L22.54 20H25C29.97 20 34 24.03 34 29V39C34 39.55 34.45 40 35 40C35.55 40 36 39.55 36 39V29C36 22.92 31.08 18 25 18Z"/>
    </g>
  `
};
